'use client'

import { useIsDesktop } from '@/_hooks/useBreakpoint'
import { IRecipe } from '@/_types'
import Desktop from './responsive/desktop'
import Mobile from './responsive/mobile'

const RecipeCard = ({
  data,
  shipperId,
}: {
  data: IRecipe
  shipperId: string
}) => {
  const isDesktop = useIsDesktop()
  return isDesktop ? (
    <Desktop data={data} shipperId={shipperId} />
  ) : (
    <Mobile data={data} shipperId={shipperId} />
  )
}

export default RecipeCard
